import type { FileMetadata } from '../../design/components';

// Type guard for FileMetadata objects
export function isFileMetadata(value: unknown): value is FileMetadata {
  return value !== null && typeof value === 'object' && 'url' in value && 'name' in value;
}

// Check if value is a valid image source
export function isValidImageSource(value: unknown): boolean {
  if (!isFileMetadata(value)) return false;
  return isValidUrl(value.url);
}

// Download image as blob to handle cross-origin files
export async function downloadImage(url: string, filename: string): Promise<void> {
  const response = await fetch(url);
  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = blobUrl;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(blobUrl);
}

function isValidUrl(url: string): boolean {
  return url.startsWith('http') ||
         url.startsWith('blob:') ||
         url.startsWith('data:image') ||
         url.startsWith('/');
}
